// extracted by mini-css-extract-plugin
export default {"cartIcon":"Notifications_cartIcon__wPS4a"};